"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.resultMessages = exports.Result = void 0;
const schema_1 = require("../../../../schema");
var Result;
(function (Result) {
    Result["ABNORMAL"] = "ABNORMAL";
    Result["NORMAL"] = "NORMAL";
})(Result || (exports.Result = Result = {}));
exports.resultMessages = {
    [Result.ABNORMAL]: {
        id: "ktx.transplantationScreening.imagingProcedures.chestXRay.result.ABNORMAL",
        defaultMessage: "Van eltérés"
    },
    [Result.NORMAL]: {
        id: "ktx.transplantationScreening.imagingProcedures.chestXRay.result.NORMAL",
        defaultMessage: "Nincs eltérés"
    }
};
const result = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Result.ABNORMAL),
    schema_1.Schema.singleChoiceItem(Result.NORMAL)
]);
const comment = schema_1.Schema.string().optional().maxLength(10000);
exports.validator = schema_1.Schema.object()
    .expiration(31536000)
    .default({})
    .sealed(true)
    .properties({ result, comment })
    .interpretation({ vocab: "ktx", code: "chest_x_ray" })
    .tag({ vocab: "snomed", code: "399208008" })
    .tag({ vocab: "loinc", code: "36572-6" })
    .tag({ vocab: "ktx", code: "imaging_procedure" })
    .tag({ vocab: "snomed", code: "20135006" });
